import { getDynamicSemanticToken } from '../../../DesignSystem';
export function getThemeToken(theme) {
    const semantic = getDynamicSemanticToken(theme);
    return {
        height: {
            small: 16,
            medium: 20,
            large: 32,
            extraLarge: 60,
        },
        borderRadius: {
            small: 4,
            medium: 4,
            large: 8,
            extraLarge: 15,
        },
        marginBottom: {
            small: 4,
            medium: 8,
            large: 16,
            extraLarge: 24,
        },
        background: {
            n: semantic.fill.subtle.neutral,
        },
    };
}
